import type { RadarMeeting } from "./model";

export const APP_BADGE_PREFERENCE_KEY = "meeting-radar-app-badge";

type BadgeNavigator = {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

type PreferenceStorage = Pick<Storage, "getItem" | "setItem">;

export function readAppBadgePreference(storage: PreferenceStorage): boolean {
  return storage.getItem(APP_BADGE_PREFERENCE_KEY) !== "off";
}

export function writeAppBadgePreference(storage: PreferenceStorage, enabled: boolean): void {
  storage.setItem(APP_BADGE_PREFERENCE_KEY, enabled ? "on" : "off");
}

export function activeMeetingCount(meetings: RadarMeeting[]): number {
  return meetings.filter((meeting) => meeting.status === "live").length;
}

export async function syncAppBadge(
  navigator: BadgeNavigator,
  count: number,
  enabled: boolean
): Promise<void> {
  try {
    if (!enabled || count <= 0) {
      if (navigator.clearAppBadge) await navigator.clearAppBadge();
      else await navigator.setAppBadge?.(0);
      return;
    }
    await navigator.setAppBadge?.(count);
  } catch {
    // Badging is progressive enhancement and must never disrupt radar state.
  }
}
